import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetEthnicities = () => {
    const {
        isFetching: isLoading, data: ethnicities, error,
    } = useQuery({
        queryKey: ["ethnicities"],
        queryFn: () => axiosManager.get$("ethnicities").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const ethnicitiesOptions = (ethnicities || []).map((item) => ({value: item.ethnicityId, label: item.name}));

    return {
        isLoading, ethnicities, error, ethnicitiesOptions,
    };
};
